import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import AnimatedSection from "../AnimatedSection";

function PrivacyPolicy() {
  return (
    <Container fluid className="privacy-section">
      <Particle />

      <Container>
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Col md={10}>
            <AnimatedSection>
            <div style={{ padding: "20px 0" }}>
              <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
                Privacy <strong className="purple">Policy</strong>
              </h1>

              <p>
                <strong>Privacy Policy for Solo AI Assistant</strong>
              </p>

              <p>
                <strong>Effective Date:</strong> March 5, 2026
              </p>

              <h2 className="purple">Our Privacy Promise</h2>

              <p>
                Your privacy is not just a policy — it is the core philosophy of
                Solo AI Assistant.
              </p>

              <p>
                We designed this app so that your AI conversations remain
                private and secure. We do not sell your personal data, and we
                prioritize protecting your information.
              </p>

              <p>
                The short version: We collect minimal information required to
                operate the app experience and never access your personal
                conversations unless explicitly required for functionality.
              </p>

              <h2 className="purple">
                1. How Your Conversations Are Handled
              </h2>

              <p>
                Your prompts and AI-generated responses ("Conversation Data")
                may be processed securely to provide AI functionality and
                improve app performance.
              </p>

              <p>
                Chat history stored inside the app remains associated with your
                device/account and can be deleted by you at any time from within
                the app.
              </p>

              <h2 className="purple">2. Information We May Collect</h2>

              <p>Depending on app functionality, we may collect:</p>

              <ul>
                <li>Basic account information (if sign-in is used)</li>
                <li>Device type and operating system version</li>
                <li>Crash logs and diagnostic information</li>
                <li>Subscription and purchase status</li>
                <li>Limited analytics to improve app performance</li>
              </ul>

              <p>We do not sell your personal information.</p>

              <h2 className="purple">3. Advertising & Third-Party Services</h2>

              <p>
                The free version of Solo AI Assistant may display ads through
                third-party advertising providers such as Google AdMob.
              </p>

              <p>
                These providers may collect:
              </p>

              <ul>
                <li>Advertising identifiers</li>
                <li>Approximate location derived from IP address</li>
                <li>Device and interaction information</li>
                <li>Ad performance metrics</li>
              </ul>

              <p>
                This information is collected and processed by the advertising
                providers under their own privacy policies.
              </p>

              <p>
                Users with an active Ad-Free subscription may not see ads within
                the app.
              </p>

              <h2 className="purple">4. Subscriptions & Payments</h2>

              <p>
                Payments and subscriptions are processed securely through Apple
                App Store and Google Play Store.
              </p>

              <p>
                We do not store your payment card information on our servers.
              </p>

              <h2 className="purple">5. AI Model & Network Usage</h2>

              <p>
                Some AI features may require internet connectivity to process
                requests, download AI models, or improve response quality.
              </p>

              <p>
                Standard network information such as IP address and device type
                may be temporarily processed as part of these services.
              </p>

              <h2 className="purple">6. Analytics & Crash Reports</h2>

              <p>
                We may receive anonymized analytics and crash reports to help us
                improve app stability and performance.
              </p>

              <p>
                These reports do not intentionally include personal
                conversations.
              </p>

              <h2 className="purple">7. Children's Privacy</h2>

              <p>
                Solo AI Assistant is not directed toward children under the age
                of 13.
              </p>

              <p>
                We do not knowingly collect personal information from children.
              </p>

              <h2 className="purple">8. Changes to This Privacy Policy</h2>

              <p>
                We may update this Privacy Policy from time to time. Changes
                will be reflected by updating the effective date on this page.
              </p>

              <p>
                Continued use of the app after changes means you accept the
                revised Privacy Policy.
              </p>

              <h2 className="purple">9. Contact Us</h2>

              <p>
                Questions or concerns about this Privacy Policy? We'd love to
                hear from you.
              </p>

              <p>
                <strong>Email:</strong> aaftabali1998@gmail.com
              </p>

            </div>
            </AnimatedSection>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default PrivacyPolicy;
